import { LayoutGenerator } from "./utils/layoutGenerator"

import { Tabs } from "materials/tabs/menus/model"
import { Pagination } from "materials/pagination/menus/model"
import { Text } from "materials/text/menus/model"
import { navMenuVertical } from "materials/navMenuVertical/menus/model"
import { Button } from "materials/button/menus/model"
import { Image } from "materials/image/menus/model"
// import { More } from "../more/model"
import { navMenu } from "materials/navMenu/menus/model"
import { BreadCrumbs } from "materials/breadCrumbs/menus/model"
/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    styleName: "自由布局",
    thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
    titleOptions: [
      {
        type: "top",
        width: 800,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 3,
            options: new Tabs({
              singleTabs: false,
              left: 0,
              top: 36,
              hoverBgColor: "rgba(61, 130, 242, 1)",
              textAlign: "center",
              hoverMaxTabLength: 5,
              borderColor: "rgba(255,255,255,0)",
              hoverBorderColor: "rgba(255,255,255,0)",
              tabBackgroundColor: "rgba(255,255,255,1)",
              tabAutoChange: false,
              autoChangeTime: 10
            })
          },
          {
            innerElement: "cxButton",
            isActive: false,
            isShow: true,
            type: "more",
            elementInLayoutId: 0,
            options: new Button({
              left: 660,
              top: 36,
              content: "更多"
            })
          }
        ],
        isShow: true,
        height: 80
      },
      {
        type: "bottom",
        width: 800,
        elementOptions: [
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: true,
            type: "pagination",
            elementInLayoutId: 0,
            options: new Pagination({})
          }
        ],
        isShow: true,
        height: 80
      },
      {
        type: "left",
        isShow: false,
        width: 120,
        height: 400,
        elementOptions: []
      },
      {
        type: "right",
        isShow: false,
        width: 120,
        height: 400,
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        }
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    titleOptions: [
      {
        type: "top",
        width: 800,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: false,
            type: "classification",
            elementInLayoutId: 3,
            options: new Tabs({
              top: 36,
              singleTabs: false,
              bgColor: "rgba(255, 255, 255, 0)",
              color: "rgba(255,255,255,0.8)",
              hoverColor: "rgba(255,255,255,0.8)",
              hoverBgColor: "#1770FF",
              textAlign: "center",
              hoverMaxTabLength: 5,
              borderColor: "rgba(255,255,255,0)",
              hoverBorderColor: "rgba(255,255,255,0)",
              tabBackgroundColor: "rgba(255,255,255,1)",
              tabAutoChange: false,
              autoChangeTime: 10
            })
          },
          {
            innerElement: "cxButton",
            isActive: false,
            isShow: false,
            type: "more",
            elementInLayoutId: 0,
            options: new Button({})
          }
        ],
        isShow: false,
        height: 80
      },
      {
        type: "bottom",
        width: 800,
        height: 80,
        isShow: false,
        elementOptions: [
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: false,
            type: "pagination",
            elementInLayoutId: 0,
            options: new Pagination({})
          }
        ]
      },
      {
        type: "left",
        isShow: false,
        width: 80,
        height: 400,
        elementOptions: []
      },
      {
        type: "right",
        isShow: false,
        width: 80,
        height: 400,
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                showAutoLayout: false,
                direction: "vertical", // vertical  horizon
                alignPositionH: "left", // left center right
                alignPositionV: "top", // top middle bottom
                marginBottom: 0, //自动布局时 组件之间的间距
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        },
      ]
    }).rows,
    pluginName: []
  }
]
/**
 * 门户自由布局默认配置数据
 */
export const appHome = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    titleOptions: [
      {
        type: "top",
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 3,
            options: new Tabs({
              singleTabs: false,
              left: 0,
              top: 36,
              hoverBgColor: "rgba(61, 130, 242, 1)",
              textAlign: "center",
              hoverMaxTabLength: 5,
              borderColor: "rgba(255,255,255,0)",
              hoverBorderColor: "rgba(255,255,255,0)",
              tabBackgroundColor: "rgba(255,255,255,1)",
              tabAutoChange: false,
              autoChangeTime: 10
            })
          },
          {
            innerElement: "cxButton",
            isActive: false,
            isShow: true,
            type: "more",
            elementInLayoutId: 0,
            options: new Button({
              left: 300,
              top: 36
            })
          }
        ],
        isShow: true,
        height: 80
      },
      {
        type: "bottom",
        elementOptions: [
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: false,
            type: "pagination",
            elementInLayoutId: 0,
            options: new Pagination({})
          }
        ],
        isShow: true,
        height: 80
      },
      {
        type: "left",
        elementOptions: [],
        isShow: true,
        width: 80
      },
      {
        type: "right",
        elementOptions: [],
        isShow: false,
        width: 80
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              componentBoxOptions: {
                bgColor: "rgba(255,255,255,0)"
              }
            }
          ]
        }
      ]
    }).rows
  }
]

// 登录样式
export const loginHome = [
  {
    width: 172,
    height: 36,
    borderWidth: 0,
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["loginLayoutComponent"],
    titleOptions: [
      {
        type: "top",
        width: 200,
        height: 80,
        isShow: false,
        elementOptions: []
      },
      {
        type: "bottom",
        width: 200,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: false,
            type: "classification",
            options: new Tabs({
              elementInLayoutId: 5,
              hoverMaxTabLength: 5,
              tabWidth: 60,
              borderColor: "rgba(255,255,255,1)",
              hoverBorderColor: "rgba(255,255,255,1)",
              tabsList: [
                { name: "未登录", content: "未登录" },
                { name: "登录后", content: "登录后" }
              ]
            })
          },
          {}
        ],
        isShow: true,
        height: 80
      },
      {
        type: "left",
        width: 80,
        height: 200,
        isShow: false,
        elementOptions: []
      },
      {
        type: "right",
        width: 80,
        height: 200,
        isShow: false,
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Button({
                  loginType: "loginBtn",
                  elementInLayoutId: 0,
                  width: 96,
                  height: 36,
                  top: 0,
                  left: 0,
                  content: "登录",
                  iconSrc: "4E6EE877E0E703DD",
                  iconType: "icon",
                  iconColor: "rgba(255,255,255,1)",
                  iconMargin: 6,
                  iconWidth: 18,
                  borderTopLeftRadius: 99,
                  borderTopRightRadius: 99,
                  borderBottomLeftRadius: 99,
                  borderBottomRightRadius: 99
                }),
                new Button({
                  loginType: "registerBtn",
                  elementInLayoutId: 1,
                  width: 96,
                  height: 36,
                  top: 0,
                  left: 100,
                  content: "注册",
                  iconSrc: "4E6EE877E0E703DD",
                  iconType: "icon",
                  iconColor: "rgba(255,255,255,1)",
                  iconMargin: 6,
                  iconWidth: 18,
                  borderTopLeftRadius: 99,
                  borderTopRightRadius: 99,
                  borderBottomLeftRadius: 99,
                  borderBottomRightRadius: 99
                })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Image({
                  loginType: "loginImage",
                  elementInLayoutId: 2,
                  width: 35,
                  height: 35,
                  top: 0,
                  left: 0,
                  innerElement: "imageComponent",
                  shapeType: "round",
                  borderTopLeftRadius: "50%",
                  borderTopRightRadiu: "50%",
                  borderBottomLeftRadius: "50%",
                  borderBottomRightRadius: "50%",
                  borderWidth: 1,
                  borderColor: "#E9E9E9"
                }),
                new navMenu({
                  loginType: "loginName",
                  elementInLayoutId: 4,
                  width: 128,
                  height: 36,
                  top: 0,
                  left: 44,
                  fontSize: 16,
                  lineHeight: 36,
                  liLineHeight: 36,
                  activeLineHeight: 36,
                  hoverLineHeight: 36,
                  selectFontColor: "rgba(0,0,0,.8)",
                  activeFontColor: "rgba(0,0,0,.8)",
                  hoverFontColor: "rgba(0,0,0,.8)",
                  hoverBgColor: "rgba(0,0,0,0)",
                  activeBgColor: "rgba(0,0,0,0)",
                  selectBgColor: "rgba(0,0,0,0)",
                  topNavPaddingLeft: 0,
                  topNavBgColor: "rgba(255,255,255,0)",
                  bgColor: "rgba(255,255,255,0)",
                  selectOptions: [
                    {
                      label: "张三",
                      value: "https://www.chaoxing.com/",
                      children: [
                        {
                          label: "进入空间",
                          // value: "http://i.chaoxing.com/",
                          children: []
                        },
                        {
                          label: "退出登录",
                          // value: window.location.protocol + "//" + window.location.hostname + "/logout?url=",
                          children: []
                        }
                      ]
                    }
                  ],
                  liWidth: 128,
                  activeBorderWidth: 0,
                  activeFontSize: 16,
                  hoverFontSize: 16,
                  hoverIsSameActive: false,
                  hoverBgIsThemeColor: false,
                  margin: 4
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]

// 列表页默认样式
export const listPage = [
  {
    width: 1170,
    height: 900,
    top: 0,
    left: 0,
    borderWidth: 0,
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["listPageComponent"],
    titleOptions: [
      {
        type: "top",
        height: 100,
        isShow: true,
        elementOptions: [
          {
            innerElement: "cxBreadCrumbs",
            isActive: false,
            isShow: true,
            type: "breadCrumbs",
            elementInLayoutId: 0,
            options: new BreadCrumbs({
              top: 0,
              left: 200
            })
          },
          {
            innerElement: "cxText",
            isActive: false,
            isShow: true,
            type: "text",
            elementInLayoutId: 1,
            options: new Text({
              top: 0,
              left: 0
            })
          }
        ]
      },
      {
        type: "bottom",
        height: 100,
        isShow: true,
        elementOptions: [
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: true,
            type: "pagination",
            elementInLayoutId: 0,
            options: new Pagination({})
          }
        ]
      },
      {
        type: "left",
        width: 200,
        isShow: true,
        elementOptions: [
          {
            innerElement: "cxNavMenuVertical",
            isActive: false,
            isShow: true,
            type: "navMenuVertical",
            elementInLayoutId: 0,
            options: new navMenuVertical({})
          }
        ]
      },
      {
        type: "right",
        width: 100,
        isShow: false,
        elementOptions: []
      }
    ],
    titleOptionsWidth: 260,
    titleOptionsHeight: 80,
    myFetchParam: {},
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              rows: [
                {
                  height: "33%",
                  cols: [
                    {
                      width: "33%"
                    },
                    {
                      width: "33%"
                    },
                    {
                      width: "33%"
                    }
                  ]
                },
                {
                  height: "33%",
                  cols: [
                    {
                      width: "33%"
                    },
                    {
                      width: "33%"
                    },
                    {
                      width: "33%"
                    }
                  ]
                },
                {
                  height: "33%",
                  cols: [
                    {
                      width: "33%"
                    },
                    {
                      width: "33%"
                    },
                    {
                      width: "33%"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }).rows
  }
]

// app登录样式
export const appLoginHome = [
  {
    width: 200,
    height: 32,
    borderWidth: 0,
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["loginLayoutComponent"],
    titleOptions: [
      {
        type: "top",
        elementOptions: [],
        isShow: false,
        height: 80
      },
      {
        type: "bottom",
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: false,
            type: "classification",
            options: new Tabs({
              elementInLayoutId: 5,
              hoverMaxTabLength: 5,
              tabWidth: 60,
              borderColor: "rgba(255,255,255,1)",
              hoverBorderColor: "rgba(255,255,255,1)",
              tabsList: [
                { name: "未登录", content: "未登录" },
                { name: "登录后", content: "登录后" }
              ]
            })
          },
          {}
        ],
        isShow: true,
        height: 80
      },
      {
        type: "left",
        elementOptions: [],
        isShow: false,
        width: 80
      },
      {
        type: "right",
        elementOptions: [],
        isShow: false,
        width: 80
      }
    ],
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Button({
                  loginType: "loginBtn",
                  elementInLayoutId: 0,
                  width: 100,
                  height: 32,
                  top: 0,
                  left: 0,
                  content: "登录",
                  iconSrc: "4E6EE877E0E703DD",
                  iconType: "icon",
                  iconColor: "rgba(255,255,255,1)",
                  iconMargin: 6,
                  iconWidth: 18
                }),
                new Button({
                  loginType: "registerBtn",
                  elementInLayoutId: 1,
                  width: 100,
                  height: 32,
                  top: 0,
                  left: 100,
                  content: "注册",
                  iconSrc: "4E6EE877E0E703DD",
                  iconType: "icon",
                  iconColor: "rgba(255,255,255,1)",
                  iconMargin: 6,
                  iconWidth: 18
                })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Image({
                  loginType: "loginImage",
                  elementInLayoutId: 2,
                  width: 32,
                  height: 32,
                  top: 0,
                  left: 0,
                  innerElement: "imageComponent",
                  shapeType: "round",
                  borderTopLeftRadius: "50%",
                  borderTopRightRadiu: "50%",
                  borderBottomLeftRadius: "50%",
                  borderBottomRightRadius: "50%"
                }),
                new navMenu({
                  loginType: "loginName",
                  elementInLayoutId: 4,
                  width: 120,
                  height: 32,
                  top: 0,
                  left: 38,
                  fontSize: 16,
                  lineHeight: 32,
                  liLineHeight: 32,
                  activeLineHeight: 32,
                  hoverLineHeight: 32,
                  selectFontColor: "rgba(0,0,0,.8)",
                  activeFontColor: "rgba(0,0,0,.8)",
                  hoverFontColor: "rgba(0,0,0,.8)",
                  hoverBgColor: "rgba(0,0,0,0)",
                  activeBgColor: "rgba(0,0,0,0)",
                  selectBgColor: "rgba(0,0,0,0)",
                  topNavPaddingLeft: 0,
                  topNavBgColor: "rgba(255,255,255,0)",
                  bgColor: "rgba(255,255,255,0)",
                  selectOptions: [
                    {
                      label: "张三",
                      value: "https://www.chaoxing.com/",
                      children: [
                        {
                          label: "进入空间",
                          value: "http://i.chaoxing.com/",
                          children: []
                        },
                        {
                          label: "退出登录",
                          value: window.location.protocol + "//" + window.location.hostname + "/logout?url=",
                          children: []
                        }
                      ]
                    }
                  ],
                  liWidth: 120,
                  activeBorderWidth: 0,
                  activeFontSize: 16,
                  hoverFontSize: 16,
                  hoverIsSameActive: false,
                  hoverBgIsThemeColor: false
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]

// app列表页默认样式
export const appListPage = [
  {
    width: 1172,
    height: 898,
    top: 0,
    left: 0,
    borderWidth: 0,
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["listPageComponentPlugin"],
    titleOptions: [
      {
        type: "top",
        elementOptions: [
          {
            innerElement: "cxBreadCrumbs",
            isActive: false,
            isShow: true,
            type: "breadCrumbs",
            elementInLayoutId: 0,
            options: new BreadCrumbs({})
          }
        ],
        isShow: true,
        height: 80
      },
      {
        type: "bottom",
        elementOptions: [
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: true,
            type: "pagination",
            elementInLayoutId: 0,
            options: new Pagination({})
          }
        ],
        isShow: true,
        height: 80
      },
      {
        type: "left",
        elementOptions: [
          {
            innerElement: "cxNavMenuVertical",
            isActive: false,
            isShow: true,
            type: "navMenuVertical",
            elementInLayoutId: 0,
            options: new navMenuVertical({})
          },
          {
            innerElement: "cxText",
            isActive: false,
            isShow: true,
            type: "text",
            elementInLayoutId: 1,
            options: new Text({})
          }
        ],
        isShow: true,
        width: 80
      },
      {
        type: "right",
        elementOptions: [],
        isShow: false,
        width: 80
      }
    ],
    titleOptionsWidth: 260,
    titleOptionsHeight: 80,
    myFetchParam: {},
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              rows: [
                {
                  height: "25%",
                  cols: [
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    }
                  ]
                },
                {
                  height: "25%",
                  cols: [
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    }
                  ]
                },
                {
                  height: "25%",
                  cols: [
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    }
                  ]
                },
                {
                  height: "25%",
                  cols: [
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    },
                    {
                      width: "25%"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
